import { Formik, FormikHelpers } from "formik";
import { ControlcenterMelcoModelsPaymentListItem, ControlcenterMelcoModelsPaymentTransDetails, useFormSubmit } from "melco-shared-logic";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
//import * as Yup from "yup";
import { DisplayProcessPaymentForm } from "./DisplayProcessPaymentForm";
import { useProcessPayment } from "../../../hooks/reports/useProcessPayment";
import { useState } from "react";

export type SubmitAction = "edit";

export type ProcessPaymentFormValueInterface = {
  id: string | null;
  transaction_id?: string;
  comments?: string;
  submitPaymentStatus?: number;
  payment_amount?: number;
};

type ProcessPaymentFormProps = {
  referenceDrawer: DrawerType;
  onCloseDrawer: (closeDrawer: boolean) => void;
  processPaymentDetails: ControlcenterMelcoModelsPaymentTransDetails | undefined;
};

export const ProcessPaymentForm: React.FC<ProcessPaymentFormProps> = ({
  referenceDrawer,
  onCloseDrawer,
  processPaymentDetails,
}) => {
  // const { t } = useTranslation();
  // const token = useUserToken();
  const processPayment = useProcessPayment();
  const [submitPaymentStatus, setSubmitPaymentStatus] = useState<number | undefined>(undefined);

  const onSubmit = async (
    values: ProcessPaymentFormValueInterface,
    formikHelpers: FormikHelpers<ProcessPaymentFormValueInterface>
  ) => {
    console.log("values ", values);
    const valuesWithStatus = {
      ...values,
      submitPaymentStatus: submitPaymentStatus, // <- status from state
    };
    console.log("values ", valuesWithStatus)
    // if (
    //   values.transaction_id != undefined &&
    //   values.transaction_id != null &&
    //   values.transaction_id != "" &&
    //   values.comments != undefined &&
    //   values.comments != null &&
    //   values.comments != ""
    // ) {
    // }
    await onProcessManually(valuesWithStatus, formikHelpers, {
      isManuallyResettingForm: true,
    });
  };

  const initialValues: ProcessPaymentFormValueInterface = {
    id: processPaymentDetails?.id ? processPaymentDetails.id : "",
    transaction_id: processPaymentDetails?.transaction_id ? processPaymentDetails.transaction_id : "",
    payment_amount: processPaymentDetails?.payment_amount ? processPaymentDetails.payment_amount : undefined,
    comments: processPaymentDetails?.comments
      ? processPaymentDetails.comments
      : "",
    submitPaymentStatus: undefined
  };

  const handleProcessPayment = async (
    values: ProcessPaymentFormValueInterface,
    formikHelpers: FormikHelpers<ProcessPaymentFormValueInterface>,
    options: {}
  ) => {
    const response = await processPayment({ ...values });
    if (response?.success) {
      formikHelpers.resetForm();
      onCloseDrawer(false);
    }
    console.log(JSON.stringify(response))
  };

  const formSubmitToProcessManually = () => {
    return [
      async (
        values: ProcessPaymentFormValueInterface,
        formikHelpers: FormikHelpers<ProcessPaymentFormValueInterface>
      ) => {
        return handleProcessPayment(values, formikHelpers, {});
      },
      {
        translationOptions: {
          batchNumber: 1,
        },
        translationPrefix: ["payments.actions", "process"].join("."),
        onError: () => {
          // refetch entity from server
          //  queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onProcessManually = useFormSubmit(...formSubmitToProcessManually());

  // const ProcessPaymentSchema = Yup.object().shape({
  //   transaction_id: Yup.string().required(),
  //   comments: Yup.string().required(),
  // });

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        // validationSchema={ProcessPaymentSchema}
        enableReinitialize
      >
        <DirtyFormPrompt>
          <DisplayProcessPaymentForm
            processPaymentDetails={processPaymentDetails}
            setSubmitPaymentStatus={setSubmitPaymentStatus}
          ></DisplayProcessPaymentForm>
        </DirtyFormPrompt>
      </Formik>
    </>
  );
};
